export default __webpack_public_path__ + "img/00b06457ff2db586981773bb928ffc34.svg";